import { always, identity, ifElse, isEmpty, map, pipe, replace, split, trim } from 'ramda';
import { isArray } from 'ramda-adjunct';

export const deserializeStringToArray: <T = string>(input: string | T[]) => T[] = ifElse(
  isArray,
  identity,
  ifElse(isEmpty, always([]), pipe(split(','), map(trim))),
);

export const normalizeUri = replace(/([a-z\-_0-9]+)\/\//gi, '$1/');
